/*
  Font Awesome Free 5.15.3 by @fontawesome
  https://fontawesome.com License - https://fontawesome.com/license/free
  (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
*/

const FolderIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
    <path d="M464 128H272l-64-64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V176c0-26.51-21.49-48-48-48z" />
  </svg>
);

export default FolderIcon;
